import Types from '../../modules/types';

import FIELDS from './fields';
import { createGetI18nFields } from '../../helpers/i18n';

// const {
//   REACT_APP_DXTOOLS_ENV,
// } = process.env;

export default ['PageOnboarding', {
  title: 'Onboarding',
  path: '/onboarding',
  exact: true,
  hidden: true,
  hideHeader: true,
  hideSidebar: true,
  activity: 'edit',
  loadUrl: '/stores/me',
  redirect: [['redirect.unauthorized']],
  // getPageFields: createGetI18nFields({ languagesDataKey: 'languages' }),
  getPageFields: createGetI18nFields({ languagesDataKey: 'languages' }),
  renderHeaderTitle: (props) => (
    props.data.onboarding.currentStep === 'END'
      ? 'You did it!'
      : Types.ONBOARDING_STEPS_LABELS_MAP[props.data.onboarding.currentStep]
  ),
  renderHeaderDescription: (props) => Types.ONBOARDING_STEPS_MAP[
    props.data?.onboarding.currentStep
  ]?.description,
  fields: [
    ...FIELDS,
    ['FieldReact', {
      name: 'redirect',
      label: null,
      renderContent: (props) => {
        if (props?.data?.onboardingComplete) {
          window.location.pathname = '/admin/orders';
        }
        return null;
      },
    }],
  ],
  actions: [
    // TODO REMOVE!!!!
    // ['ActionWithFormBasedRequest', {
    //   name: 'onboardingPrev',
    //   title: 'Previous (DEV ONLY)',
    //   method: 'post',
    //   type: 'danger',
    //   disabled: [() => false],
    //   handleSuccess: (data, props) => props.reload(),
    //   // eslint-disable-next-line arrow-body-style
    //   getRequestConfig: (props, data) => {
    //     return {
    //       url: `/stores/onboardingPrevDev/${props.data._id}`,
    //       method: 'POST',
    //       data: {
    //         ...data,
    //       },
    //     };
    //   },
    //   skip: [() => REACT_APP_DXTOOLS_ENV !== 'development'],
    // }],
    ...[

      [
        'Next',
        'onboardingNext',
        props => props.data.onboarding.currentStep === 'END',
        (data, props) => props.reload(),
      ],
      [
        'Pay Now and Activate Your Store',
        'onboardingPayNow',
        props => props.data.onboarding.currentStep !== 'END',
        () => { window.location.pathname = '/admin/store/subscription'; },
        true,
        false,
      ],
      // [
      //   'Configure Products',
      //   'onboardingProducts',
      //   props => props.data.onboarding.currentStep !== 'END',
      //   () => { window.location.pathname = '/admin/store/products'; },
      //   true,
      // ],
      [
        'Go To Dashboard',
        'onboardingHomepage',
        props => props.data.onboarding.currentStep !== 'END',
        () => {
          window.location.pathname = '/admin/orders';
        },
        false,
        true,
      ],
    ].map(
      ([title, name, skip, handleSuccess, ghost = false, right = true]) => ([
        'ActionWithFormBasedRequest',
        {
          name,
          title,
          method: 'post',
          type: 'primary',
          ghost,
          right,
          disabled: [() => false],
          skip: [props => skip(props)],
          handleSuccess,
          // eslint-disable-next-line arrow-body-style
          getRequestConfig: (props, data) => {
            return {
              url: `/stores/onboarding/${props.data._id}`,
              method: 'POST',
              data: {
                ...data,
              },
            };
          },
        },
      ])
    ),
  ],
}];
